
export class DeliveryCloseDTO{
    public Comment?: string = undefined;
}